import api from "./api";

function toParams({ page, pageSize, search, sortBy, sortOrder, ...rest } = {}) {
    const params = { ...rest };
    if (page) params.page = page;
    if (pageSize) params.page_size = pageSize;
    if (search) params.search = search;
    if (sortBy) params.sort_by = sortBy;
    if (sortOrder) params.sort_order = sortOrder;
    return params;
}

export const proposalsService = {
    async list(query = {}) {
        const { data } = await api.get("/proposals", { params: toParams(query) });
        return data;
    },
    async get(id) {
        const { data } = await api.get(`/proposals/${id}`);
        return data;
    },
    async meta() {
        const { data } = await api.get("/proposals/meta");
        return data;
    },
    async dashboard() {
        const { data } = await api.get("/proposals/dashboard");
        return data;
    },
    async createFromWorkshop(workshopId) {
        const { data } = await api.post(`/proposals/from-workshop/${workshopId}`);
        return data;
    },
    async create(payload) {
        const { data } = await api.post("/proposals", payload);
        return data;
    },
    async patch(id, payload) {
        const { data } = await api.patch(`/proposals/${id}`, payload);
        return data;
    },
    async addService(id, payload) {
        const { data } = await api.post(`/proposals/${id}/services`, payload);
        return data;
    },
    async updateService(id, serviceId, payload) {
        const { data } = await api.patch(`/proposals/${id}/services/${serviceId}`, payload);
        return data;
    },
    async removeService(id, serviceId) {
        const { data } = await api.delete(`/proposals/${id}/services/${serviceId}`);
        return data;
    },
    async addPart(id, payload) {
        const { data } = await api.post(`/proposals/${id}/parts`, payload);
        return data;
    },
    async updatePart(id, partId, payload) {
        const { data } = await api.patch(`/proposals/${id}/parts/${partId}`, payload);
        return data;
    },
    async removePart(id, partId) {
        const { data } = await api.delete(`/proposals/${id}/parts/${partId}`);
        return data;
    },
    async send(id) {
        const { data } = await api.post(`/proposals/${id}/send`);
        return data;
    },
    async approve(id, payload = {}) {
        const { data } = await api.post(`/proposals/${id}/approve`, payload);
        return data;
    },
    async reject(id, payload = {}) {
        const { data } = await api.post(`/proposals/${id}/reject`, payload);
        return data;
    },
    async cancel(id, payload = {}) {
        const { data } = await api.post(`/proposals/${id}/cancel`, payload);
        return data;
    },
    async generatePdf(id) {
        const { data } = await api.post(`/proposals/${id}/generate-pdf`);
        return data;
    },
    async ensurePdf(id) {
        const { data } = await api.post(`/proposals/${id}/pdf/ensure`);
        return data;
    },
    async remove(id) {
        await api.delete(`/proposals/${id}`);
    },
};
